var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5985_13072",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 35
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5985_13072)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.18943 29.1667C7.51811 29.1667 6.95763 28.9419 6.50798 28.4922C6.05832 28.0425 5.8335 27.4821 5.8335 26.8107V8.18928C5.8335 7.51796 6.05832 6.95748 6.50798 6.50782C6.95763 6.05817 7.51811 5.83334 8.18943 5.83334H26.8109C27.4822 5.83334 28.0427 6.05817 28.4924 6.50782C28.942 6.95748 29.1668 7.51796 29.1668 8.18928V26.8107C29.1668 27.4821 28.942 28.0425 28.4924 28.4922C28.0427 28.9419 27.4822 29.1667 26.8109 29.1667H8.18943ZM8.18943 27.7083H26.8109C27.0355 27.7083 27.2412 27.6149 27.4281 27.428C27.615 27.2411 27.7085 27.0353 27.7085 26.8107V8.18928C27.7085 7.9647 27.615 7.75895 27.4281 7.57204C27.2412 7.38513 27.0355 7.29168 26.8109 7.29168H8.18943C7.96485 7.29168 7.7591 7.38513 7.57219 7.57204C7.38528 7.75895 7.29183 7.9647 7.29183 8.18928V26.8107C7.29183 27.0353 7.38528 27.2411 7.57219 27.428C7.7591 27.6149 7.96485 27.7083 8.18943 27.7083ZM10.9377 24.0625H24.2869L20.1645 18.5657L16.3503 23.3895L13.7982 20.3044L10.9377 24.0625Z",
    fill: "#009A50"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.6c3276a0b0b79a397e08a166ec3ffcaa.svg";
export { ForwardRef as ReactComponent };